import { makesQueries } from 'data/graphql'
import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import {
  viewIsLoading,
  viewHasLoaded,
  viewFailedToLoad,
} from 'data/ui/viewState'

const noop = () => {}

const getApplicationInviteSettingsQuery = gql`
  fragment InviteTargetAttrs on InviteTarget {
    id
    type
    label
    subLabel
    required
    autofocus
    initialValue
  }

  fragment InviteValueOptionAttrs on InviteValueOption {
    label
    subLabel
    metadata
    value
  }

  fragment InviteTarget on InviteTarget {
    ...InviteTargetAttrs
    options {
      ...InviteValueOptionAttrs
    }
  }
  query getApplicationInviteSettings($clientId: ID!) {
    getApplicationInviteSettings(clientId: $clientId) {
      needsUserAssociation {
        redirectUrl
      }
      targets {
        ...InviteTarget
      }
    }
  }
`

export default function withGetApplicationInviteSettings({
  viewName = 'loadInviteSettings',
  onInviteSettingsFetched = noop,
  mapPropsToVariables = ({ clientId }) => ({
    clientId,
  }),
  queryOnChanges,
}) {
  return compose(
    connect(
      null,
      { viewIsLoading, viewHasLoaded, viewFailedToLoad }
    ),
    makesQueries({
      query: getApplicationInviteSettingsQuery,
      queryOnChanges,
      mapPropsToVariables,
      getOnQueryFromProps: ({ viewIsLoading }) => () =>
        viewIsLoading(viewName, ''),
      getOnResultFromProps: props => ({ result }) => {
        const data = result.data.getApplicationInviteSettings
        // @ts-ignore
        onInviteSettingsFetched(props, {
          ...data,
        })

        props.viewHasLoaded(viewName, '')
      },
      getOnErrorFromProps: ({ viewFailedToLoad }) => ({ error }) =>
        viewFailedToLoad(viewName, '', error),
    })
  )
}
